import { Button, InteractiveContainer, Tooltip } from "@jugl-web/ui-kit";
import { ReactNode } from "react";

type WorkspaceTileProps = {
  onClick?: () => void;
  children: ReactNode;
  tooltipText?: string;
  buttonText?: string;
};

export const WorkspaceTile = ({
  onClick,
  children,
  tooltipText,
  buttonText,
}: WorkspaceTileProps) => (
  <InteractiveContainer
    onClick={() => onClick?.()}
    className="font-poppins group relative flex h-[260px] min-w-[288px] items-center justify-center rounded-xl bg-[#F7F8F9] duration-300 hover:drop-shadow-[0_4px_8px_rgba(0,0,0,0.12)]"
  >
    {tooltipText && (
      <Tooltip
        placement="top"
        renderTrigger={({ props, ref }) => (
          <div
            className="absolute top-[23px] right-[23px] h-[18px] w-[18px] rounded-full bg-[#D2D2D8] text-center text-white hover:bg-[#6192BE]"
            ref={ref}
            {...props}
          >
            i
          </div>
        )}
      >
        <div className="text-center">{tooltipText}</div>
      </Tooltip>
    )}
    {children}
    {buttonText && (
      <Button className="absolute bottom-[50px] w-max opacity-0 duration-300 group-hover:opacity-100">
        {buttonText}
      </Button>
    )}
  </InteractiveContainer>
);
